import { createAction, props } from '@ngrx/store';

import { Menu } from '../../models/menu';

export const setSnapshot = createAction('[Menus] Reflete os menus utilizados no app', props<{ payload: Menu[] }>());
export const setDisplayState = createAction('[Menus] Altera o estado de exibição do menu', props<{ payload: 'open' | 'closed' }>());
export const clickOnItem = createAction('[Menus] É chamada quando um item no menu é clicado');
export const toggle = createAction('[Menus] Inverte o estado de exibição do menu');
